import http from '../http'
import { IGetTransactionListResponse, ITransactionDto, ITransactionStatisticDto } from './dtos'
import { mapTransactionFromDto, mapTransactionStatisticFromDto, mapTransactionToDto } from './helpers'
import {
	IGetTransactionListParams,
	ITransaction,
	ITransactionList,
	ICSVUploadParams,
	ICombineTransferParams,
} from './models'

const transactionsAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/transactions`)
const transfersAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/transfers`)

export const getTransactions = async (params: IGetTransactionListParams): Promise<ITransactionList> => {
	const { data } = await transactionsAPI.get<IGetTransactionListResponse>('', {
		params: {
			'date-from': params.dateFrom,
			'date-to': params.dateTo,
			page: params.page,
			size: params.size,
			'needs-review': params.needsReview,
			'manual-entry': params.manualEntry,
			'filter-key': params.filterKey,
			types: params.types,
			desc: params.desc,
			asc: params.asc,
			integrationIds: params.integrationIds,
			walletIds: params.walletIds,
		},
	})
	return {
		filteredItems: data.filteredTransactionCount,
		totalItems: data.totalTransactionCount,
		page: params.page,
		pageSize: params.size,
		items: data.transactions.map(mapTransactionFromDto),
	}
}

export const getTransactionStatistic = async () => {
	const { data } = await transactionsAPI.get<ITransactionStatisticDto>('/statistics')
	return mapTransactionStatisticFromDto(data)
}

export const getTransactionById = async (id: ITransaction['id']) => {
	const { data } = await transactionsAPI.get<ITransactionDto>(`/${id}`)
	return mapTransactionFromDto(data)
}

export const addTransaction = async (params: ITransaction) => {
	const { data } = await transactionsAPI.post('', mapTransactionToDto(params))
	return data
}

export const editTransaction = async (params: ITransaction) => {
	const { data } = await transactionsAPI.put('', mapTransactionToDto(params))
	return data
}

export const csvTransactionImport = async (params: ICSVUploadParams) => {
	const { data } = await transactionsAPI.post('/csv', params)
	return data
}

export const approveNeedsReviewTransaction = async (id: ITransaction['id']) => {
	const { data } = await transactionsAPI.post(`/${id}/approve`)
	return data
}

export const removeTransaction = async (id: ITransaction['id']) => {
	const { data } = await transactionsAPI.delete(`/${id}`)
	return data
}

export const removeAllTransaction = async () => {
	const { data } = await transactionsAPI.delete(``)
	return data
}

export const combineTransfer = async (params: ICombineTransferParams) => {
	const { data } = await transfersAPI.post('', params)
	return data
}

export const combineTransfersAuto = async () => {
	const { data } = await transfersAPI.post('/auto')
	return data
}
